import Vue from 'vue'
import { API_URL } from '@/config'

export const mailings = {

  namespaced: true,

  state: {
    mailings: [],
  },

  getters: {
    mailings: state => state.mailings,
  },

  mutations: {
    setMailings(state, mailings) { state.mailings = mailings },
    clearList(state) {
      state.mailings = [];
    },
  },

  actions: {

    getMailings: () => Vue.axios.get(API_URL + '/mailings', { params: {
      sorts: [{"column":"id","order":"asc"}]
    }}),

    async getList({ commit, dispatch }) {
      const mailings = await dispatch('getMailings');
      commit('setProgress', false, { root: true });
      commit('setMailings', mailings.data.items);
    }

  }
}
